import { inject, Injectable } from '@angular/core';
import { assertGraphqlDataNode, type TypePick } from '@reconcept-platform/shared/data-access';
import {
  type SubDomain,
  type SubDomainTitleQueryQuery,
  type SubDomainTitleQueryQueryVariables,
  type SubDomainWithMostSevereSeverityQueryQuery,
  type SubDomainWithMostSevereSeverityQueryQueryVariables,
  type WorkspaceFilter,
} from '@reconcept-platform/shared/types';
import { type Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';
import { SubDomainTitleQuery, SubDomainWithMostSevereSeverityQuery } from './sub-domain.queries';

@Injectable({
  providedIn: 'root',
})
export class SubDomainApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  getSubDomainTitle(subDomainId: string): Observable<TypePick<SubDomain, 'title'>> {
    return this.watchSubDomainTitleById(subDomainId).pipe(take(1));
  }

  watchSubDomainWithSeverity(subDomainId: string, workspaceFilter: WorkspaceFilter) {
    return this.workspaceGraphQLService
      .watchQuery<SubDomainWithMostSevereSeverityQueryQuery, SubDomainWithMostSevereSeverityQueryQueryVariables>({
        query: SubDomainWithMostSevereSeverityQuery,
        variables: {
          id: subDomainId,
          filter: workspaceFilter,
        },
      })
      .pipe(map((result) => assertGraphqlDataNode(result, 'SubDomain')));
  }

  private watchSubDomainTitleById(subDomainId: string): Observable<TypePick<SubDomain, 'title'>> {
    return this.workspaceGraphQLService
      .watchQuery<SubDomainTitleQueryQuery, SubDomainTitleQueryQueryVariables>({
        query: SubDomainTitleQuery,
        variables: {
          id: subDomainId,
        },
      })
      .pipe(map((result) => assertGraphqlDataNode(result, 'SubDomain')));
  }
}
